import {useCallback} from 'react';

import {downloadFile} from '../utils/downloadFile';
import type {DownloadOptions, UseFileDownloadResult} from '../types/file';

/**
 * 文件下载 Hook
 *
 * @returns download 方法用于触发浏览器原生下载。
 *
 * @example
 * const { download } = useFileDownload();
 * download({ url: fileUrl, fileName: '角色视频.mp4' });
 */
export function useFileDownload(): UseFileDownloadResult {
    const download = useCallback((options: DownloadOptions) => {
        downloadFile(options);
    }, []);

    const downloadAll = useCallback((optionsList: DownloadOptions[]) => {
        for (const options of optionsList) {
            downloadFile(options);
        }
    }, []);

    return {download, downloadAll};
}
